<template>
  <v-list>
    <v-list-item-group>
      <v-list-item v-for="(relance, i) in relances" :key="i">
        <v-list-item-content>
          <v-list-item-title class="text-h3 white--text blue-grey pa-2">
            <v-row class="text-h3 white--text blue-grey pa-3">
              {{ relance.user }} le {{ relance.created_at }}
              <v-spacer />
              {{ relance.orig }}
            </v-row>
          </v-list-item-title>
          <span v-html="sanitizedTextContent(relance.commentaire)"></span>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { userMixin } from "@/mixins/user";
import { sanitizedTextContent } from "@/common/lib";

export default {
  name: "VueAfficheRelances",
  mixins: [userMixin],
  data() {
    return {
      sanitizedTextContent: sanitizedTextContent,
    };
  },
  props: {
    relances: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped></style>
